import BaseComponent from '../base-component/base-component'
import FloatElement from '../float-element/float-element'
import { Nullable } from '../../types/common'

class CountrySelector extends BaseComponent {
  input: Nullable<HTMLInputElement>
  dropdown: Nullable<FloatElement>
  dropdownBtnLabel: Nullable<HTMLElement>
  items: HTMLElement[]

  constructor() {
    super()

    this.input = this.querySelector('input')
    this.dropdown = this.querySelector('float-element')
    this.dropdownBtnLabel = this.querySelector('.dropdown__toggle-label')

    this.createItems()

    this.items = [...this.querySelectorAll('.dropdown__item')] as HTMLElement[]
  }

  connectedCallback(): void {
    this.items.forEach(item => {
      item.addEventListener('click', this.handleItemClick)
    })
  }

  disconnectedCallback(): void {
    this.items.forEach(item => {
      item.removeEventListener('click', this.handleItemClick)
    })
  }

  handleItemClick = (event): void => {
    if (!this.input || !this.dropdownBtnLabel || !this.dropdown) {
      return
    }

    this.input.setAttribute('value', event.target.dataset.value)

    this.setActiveItem(event.target.dataset.value)

    this.dropdownBtnLabel.innerHTML = event.target.dataset.value
    this.dropdown.hide()
  }

  setActiveItem(activeCountryValue: string): void {
    this.items.forEach(item => {
      item.classList.toggle('active', item.dataset.value === activeCountryValue)
    })
  }

  createItems(): void {
    const options = this.querySelectorAll('option')
    const fragment = document.createDocumentFragment()

    if (!this.dropdown) {
      return
    }

    options.forEach(option => {
      const item = document.createElement('div')
      const clonedOption = option.cloneNode(true)

      item.classList.add('dropdown__item')
      item.dataset.value = option.value
      item.dataset.provinces = option.dataset.provinces
      item.replaceChildren(...clonedOption.childNodes)

      fragment.appendChild(item)
    })

    this.dropdown.replaceChildren(...fragment.childNodes)
  }
}

export default CountrySelector
